export const programsQuery = `
query GetPrograms {
  programs {
    id
    name
    constraints {
      gender
      sport
      userLevel
      category
      material
      specialProgram
      pathology
      weekFocus
    }
    status
    lastUpdateDate
  }
}
`

export const programByIdQuery = `
query GetProgramById($id: ID!) {
  program(id: $id) {
    id
    name
    status
    lastUpdateDate
    constraints {
      gender
      sport
      userLevel
      category
      material
      specialProgram
      pathology
      weekFocus
    }
    description {
      language
      text
    }
    displayName {
      language
      text
    }
    poster {
      height
      source
      width
    }
    programConstrained {
      id
      name
      status
      lastUpdateDate
      description {
        language
        text
      }
      displayName {
        language
        text
      }
      poster {
        height
        source
        width
      }
      steps {
        options {
          displayName {
            language
            text
          }
          duration
          name
          repetitions
          constraints {
            gender
            sport
            userLevel
            category
            material
            specialProgram
            pathology
            weekFocus
          }
          exercises {
            options {
              duration
              recuperation
              repetitions
              series
              exercise {
                id
                name
                lastUpdateDate
                sideChange
                description {
                  language
                  text
                }
                displayName {
                  language
                  text
                }
                poster {
                  source
                  height
                  width
                }
                backgroundVideo {
                  duration
                  source
                  title
                }
                videos {
                  language
                  video {
                    duration
                    height
                    source
                    title
                    width
                  }
                }
              }
              constraints {
                gender
                sport
                userLevel
                category
                material
                specialProgram
                pathology
                weekFocus
              }
            }
          }
        }
      }
    }
  }
}
`

export const programConstrainedByIdQuery = `
query GetProgramConstrainedById($id: ID!) {
  programConstrained(id: $id) {
    id
    name
    status
    lastUpdateDate
    description {
      language
      text
    }
    displayName {
      language
      text
    }
    poster {
      height
      source
      width
    }
    steps {
      options {
        displayName {
          language
          text
        }
        duration
        name
        repetitions
        constraints {
          gender
          sport
          userLevel
          category
          material
          specialProgram
          pathology
          weekFocus
        }
        exercises {
          options {
            duration
            recuperation
            repetitions
            series
            exercise {
              id
              name
              lastUpdateDate
              sideChange
              description {
                language
                text
              }
              displayName {
                language
                text
              }
              poster {
                source
                height
                width
              }
              backgroundVideo {
                duration
                source
                title
              }
              videos {
                language
                video {
                  duration
                  height
                  source
                  title
                  width
                }
              }
            }
            constraints {
              gender
              sport
              userLevel
              category
              material
              specialProgram
              pathology
              weekFocus
            }
          }
        }
      }
    }
  }
}
`

export const constrainedProgramsQuery = `
query GetConstrainedPrograms {
  programsConstrained {
    id
    name
    lastUpdateDate
  }
}
`

export const createProgramMutation = `
mutation createProgramConstrained($programConstrained: ProgramConstrainedInput!) {
  createProgramConstrained(programConstrained: $programConstrained) {
    id
    name
    status
    lastUpdateDate
  }
}
`

export const updateProgramMutation = `
mutation updateProgramConstrained($id: ID!, $programConstrained: ProgramConstrainedUpdateInput!) {
  updateProgramConstrained(id: $id, programConstrained: $programConstrained) {
    id
    name
    status
    lastUpdateDate
  }
}
`

export const createProgramConstrainedMutation = `
mutation createProgramConstrained($programConstrained: ProgramConstrainedInput!) {
  createProgramConstrained(programConstrained: $programConstrained) {
    id
    name
    status
    lastUpdateDate
  }
}
`

export const updateProgramConstrainedMutation = `
mutation updateProgramConstrained($id: ID!, $programConstrained: ProgramConstrainedUpdateInput!) {
  updateProgramConstrained(id: $id, programConstrained: $programConstrained) {
    id
    name
    status
    lastUpdateDate
  }
}
`

export const exercisesQuery = `
query GetExercises {
  exercises {
    id
    name
    lastUpdateDate
  }
}
`

export const exerciseByIdQuery = `
query GetExerciseById($id: ID!) {
  exercise(id: $id) {
    id
    name
    backgroundVideo {
      duration
      source
      title
    }
    description {
      language
      text
    }
    displayName {
      language
      text
    }
    poster {
      source
    }
    sideChange
    videos {
      language
      video {
        duration
        height
        source
        title
        width
      }
    }
  }
}
`

export const constantsQuery = `
query GetConstants {
  constants {
    categories
    genders
    languageCodes
    materials
    pathologies
    programSports
    sessionFlags
    specialPrograms
    userLevels
    weekFocus
    workoutFocus
    workoutSports
  }
}
`

export const deleteProgramConstrainedMutation = `
mutation deleteProgramConstrained($id: ID!) {
  deleteProgramConstrained(id: $id)
}
`
export const workoutInfoQuery = `
query {
	workoutInfos {
    id,
    name,
    displayName {
      language,
      text
    },
    videos {
      language,
      video {
        source, title
      }
    },
    selector {
      focus,
      sport,
      flags
    },
    status
  }
}
`

export const workoutInfoByIdQuery = `
query GetWorkoutInfoById($id: ID!) {
	workoutInfo(id: $id) {
    id,
    name,
    lastUpdateDate,
    videos {
      language,
      video {
        source,
        title,
        duration
      }
    },
    displayName {
      language,
      text
    },
    description {
      language,
      text
    }
    poster {
      source
    },
    selector {
      focus,
      sport,
      flags,
      timeMin,
      timeMax,
      distanceMin,
      distanceMax,
      dplusMin,
      dplusMax
    },
    status,
    lastUpdateDate
  }
}
`

export const START_UPLOAD_MUTATION = `
  mutation StartVideoUpload($videoType: String!, $filename: String!, $sizeBytes: Int!, $sha256: String, $parts: Int!) {
    startVideoUpload(videoType: $videoType, filename: $filename, sizeBytes: $sizeBytes, sha256: $sha256, parts: $parts) {
      sessionId
      uploadId
      key
      maxPartSize
      partUrls { partNumber url }
    }
  }
`;

export const GET_PART_URLS_MUTATION = `
  mutation GetUrls($sessionId: String!, $parts: [Int!]!) {
    getPartUrls(sessionId: $sessionId, partNumbers: $parts) {
      partNumber
      url
    }
  }
`;


export const COMPLETE_UPLOAD_MUTATION = `
  mutation CompleteUpload($sessionId: String!, $parts: [[String!]!]!) {
    completeUpload(sessionId: $sessionId, parts: $parts) {
      id
      status
      publicUrl
      posterUrl
      error
    }
  }
`;

export const POLL_ASSET_QUERY = `
  query VideoAsset($id: ID!) {
    videoAsset(id: $id) {
      id
      status
      publicUrl
      posterUrl
      error
    }
  }
`;
